const currency = require('../currency')

const timeActivitySpentAmount = (activity, timeSpent, userRate) => {
  let spentAmount = 0
  if (
    !activity.bUseTotal &&
      activity.pricePerHour !== 0 &&
      activity.pricePerHour !== ''
  ) {
    spentAmount = activity.pricePerHour * (timeSpent / 60)
  } else {
    spentAmount = userRate * (timeSpent / 60)
  }

  return currency.round(spentAmount)
}

const percentage = (curVal, totalVal) => {
  return curVal && totalVal
    ? parseInt(Math.round((curVal / totalVal) * 100))
    : 0
}

const rateFromTime = (timeTakenInMins, rate) => {
  const total = rate * (timeTakenInMins / 60)
  return parseFloat(total.toFixed(2))
}

const calculateVatFromItems = (items) => {
  let total = 0
  let totalInc = 0
  let vats = []
  const vatMap = {}

  if (items && items.length > 0) {
    items.forEach(item => {
      if (item.type !== 'subtotal' && item.type !== 'pagebreak') {
        const vat = parseFloat(item.vat)
        let vatInfo = vatMap[vat]

        if (!vatInfo) {
          vatInfo = {
            total: 0,
            vat: vat,
            vatAmount: 0
          }

          vatMap[vat] = vatInfo
        }

        const itemTotal = parseFloat(item.total)
        vatInfo.total += itemTotal
        total += itemTotal
      }
    })
  }

  let totalVatAmount = 0
  Object.keys(vatMap).forEach(vat => {
    const vatInfo = vatMap[vat]
    vatInfo.vatAmount = currency.getVatAmount(vatInfo.total, vat)
    totalVatAmount += vatInfo.vatAmount

    if (vatInfo.vatAmount !== 0) {
      vats.push({
        vat: vatInfo.vat,
        amount: vatInfo.vatAmount
      })
    }
  })

  totalVatAmount = parseFloat(totalVatAmount)
  total = currency.round(total)
  totalInc = currency.round(total + totalVatAmount)
  vats = vats.sort((a, b) => {
    if (a.vat < b.vat) return -1
    if (a.vat > b.vat) return 1
    return 0
  })

  return {
    total,
    totalInc,
    totalVatAmount,
    vats
  }
}

const getFileLanguage = (object, contact, team) => {
  let language = 'en'

  const isUS = team && team.profile && team.profile.country === 'US'

  if (object) {
    if (object.pdfLanguage) {
      language = object.pdfLanguage
    } else if (contact && contact.pdfLanguage) {
      language = contact.pdfLanguage
    } else if (object.contactAddress && object.contactAddress.country) {
      if (object.contactAddress.country === 'UK') {
        language = 'en'
      } else {
        language = object.contactAddress.country
      }
    }
  }

  return (isUS ? 'us' : language).toLowerCase()
}

module.exports = {
  timeActivitySpentAmount,
  percentage,
  rateFromTime,
  calculateVatFromItems,
  getFileLanguage
}
